(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("g7m2H", function(module, exports) {
class $bbbe65f8167975af$var$Header extends HTMLElement {
    constructor(){
        super();
        this.props = {
            activeMenu: "main",
            activePillClass: "--active",
            arrowDirection: "",
            arrowPosition: 0,
            baseClass: "js-header",
            bodyOpenClass: "--header-open",
            hiddenClass: "--hidden",
            isHandheld: false,
            isPopoverOpen: false,
            openClass: "--open",
            lastScrollY: 0,
            headerVisible: true,
            headerVisibleClass: "--hide",
            scrollClass: "--scroll"
        };
        // Props Proxy to observe prop changes
        this.propsProxy = new Proxy(this.props, {
            set: (target, key, value)=>{
                const oldValue = target[key];
                // Set new value
                target[key] = value;
                // Handle prop changes
                this.propsHandler(key, value, oldValue);
                return true;
            }
        });
        this.els = {
            arrow: this.querySelector(`.${this.props.baseClass}-arrow`),
            closeButton: this.querySelector(`.${this.props.baseClass}-close`),
            navigation: this.querySelector(`.${this.props.baseClass}-nav`),
            navigationMenus: this.querySelectorAll(`.${this.props.baseClass}-nav-menu`),
            navigationTriggers: this.querySelectorAll(`.${this.props.baseClass}-nav-trigger`),
            openButton: this.querySelector(`.${this.props.baseClass}-open`),
            popover: this.querySelector(`.${this.props.baseClass}-popover`),
            popoverSections: this.querySelectorAll(`.${this.props.baseClass}-popover-section`),
            navigationSingleLevelTriggers: this.querySelectorAll(`.${this.props.baseClass}-nav-single`)
        };
    }
    changeArrowDirection() {
        if (!this.props.arrowDirection) return;
        const leftClass = "--left";
        const rightClass = "--right";
        const config = {
            left: {
                add: leftClass,
                remove: rightClass
            },
            right: {
                add: rightClass,
                remove: leftClass
            }
        };
        const classList = this.els.popover?.classList;
        if (!classList) return;
        const useConfig = (action)=>config[this.props.arrowDirection][action];
        classList.remove(useConfig("remove"));
        classList.add(useConfig("add"));
    }
    handleScroll() {
        const { lastScrollY: lastScrollY, baseClass: baseClass, scrollClass: scrollClass } = this.props;
        const currentScrollY = window.scrollY;
        const scrollingDown = currentScrollY > lastScrollY;
        const headerHeight = this.offsetHeight; // Altura del encabezado para consideraciones adicionales
        const siblingHeaderHeight = this.parentElement.nextElementSibling && this.parentElement.nextElementSibling.tagName.toLowerCase() === "m-secondarymenu" ? this.parentElement.nextElementSibling.offsetHeight : 0;
        const totalHeight = headerHeight + siblingHeaderHeight;
        const menu = document.querySelector(`.${baseClass}`).parentElement.id === "v3" ? document.querySelector(`.${baseClass}`).parentElement : document.querySelector(`.${baseClass}`);
        // Si el scroll es 0, quita todas las clases
        if (currentScrollY === 0) {
            menu.classList.remove(`${scrollClass}`, `${scrollClass}-up`);
            this.propsProxy.headerVisible = true; // Asumiendo que propsProxy actualiza tu estado correctamente
            return; // Termina la ejecución aquí
        }
        // Comportamiento cuando se desplaza hacia abajo y supera totalHeight
        if (scrollingDown && currentScrollY > totalHeight) {
            if (this.props.headerVisible) {
                this.propsProxy.headerVisible = false; // Actualiza el estado
                menu.classList.remove(`${scrollClass}-up`);
                menu.classList.add(`${scrollClass}`);
            }
        } else if (!scrollingDown && currentScrollY > 0) // Comportamiento cuando se desplaza hacia arriba y no está en 0
        {
            if (!this.props.headerVisible) {
                this.propsProxy.headerVisible = true; // Actualiza el estado
                menu.classList.remove(`${scrollClass}`);
                menu.classList.add(`${scrollClass}-up`);
            }
        }
        // Actualiza la última posición de scroll
        this.propsProxy.lastScrollY = currentScrollY;
    }
    changeArrowPosition() {
        if (!this.els.arrow) return;
        this.els.arrow.style.transform = `translate(${parseInt(this.props.arrowPosition)}px)`;
    }
    closePopover() {
        document.body.classList.remove(this.props.bodyOpenClass);
        this.classList.remove(this.props.openClass);
        if (this.els.popover) this.els.popover.classList.remove("--left", "--right");
    }
    getActiveMenu() {
        return Array.from(this.els.navigationMenus).filter((menu)=>{
            return menu.dataset.headerMenu === this.props.activeMenu;
        })[0];
    }
    getArrowPosition() {
        // Don't move arrow if is tablet or lower
        if (this.props.isHandheld) return;
        const viewportWidth = window.innerWidth;
        const activeTrigger = Array.from(this.els.navigationTriggers).filter((trigger)=>{
            return trigger.dataset.headerMenu === this.props.activeMenu;
        })[0];
        if (!activeTrigger) return;
        const viewportCenter = viewportWidth / 2;
        const { width: width, x: x } = activeTrigger.getBoundingClientRect();
        const triggerPosition = x + width / 2;
        const arrowPosition = (viewportCenter - triggerPosition) * -1;
        return arrowPosition;
    }
    hidePill(section, e) {
        const pill = section.querySelector(".js-header-popover-pill");
        if (pill) pill.classList.remove(this.props.activePillClass);
    }
    navigationHandler(e) {
        if (e.target.classList.contains(`${this.props.baseClass}-nav-single`)) {
            if (this.propsProxy.isPopoverOpen) this.propsProxy.isPopoverOpen = false;
            return;
        }
        if (!e.target.classList.contains(`${this.props.baseClass}-nav-trigger`)) return;
        const menuId = e.target.dataset.headerMenu;
        this.propsProxy.isPopoverOpen = true;
        this.propsProxy.activeMenu = menuId;
    }
    openPopover() {
        document.body.classList.add(this.props.bodyOpenClass);
        this.classList.add(this.props.openClass);
    }
    propsHandler(prop, newValue, oldValue) {
        if (prop === "activeMenu") this.toggleMenu();
        if (prop === "arrowDirection") this.changeArrowDirection();
        if (prop === "arrowPosition") this.changeArrowPosition();
        if (prop === "isPopoverOpen") this.togglePopover();
    }
    resizeHandler() {
        this.setHandheld();
        if (this.props.isPopoverOpen) {
            this.setArrowPosition();
            this.setPopoverHeight();
        }
    }
    setArrowDirection(arrowOldPosition) {
        this.propsProxy.arrowDirection = this.propsProxy.arrowPosition > arrowOldPosition ? "right" : "left";
    }
    setArrowPosition() {
        const arrowOldPosition = this.props.arrowPosition;
        const arrowPosition = this.getArrowPosition();
        this.propsProxy.arrowPosition = arrowPosition;
        this.setArrowDirection(arrowOldPosition);
    }
    setHandheld() {
        this.propsProxy.isHandheld = window.innerWidth <= 1080;
    }
    setPopoverHeight(activeMenu) {
        if (this.props.isHandheld) return;
        activeMenu = activeMenu || this.getActiveMenu();
        if (!activeMenu) return;
        const menuHeight = activeMenu.getBoundingClientRect().height;
        if (this.els.popover) this.els.popover.style.height = `${menuHeight}px`;
    }
    hideLinksHeader() {
        const urlParams = new URLSearchParams(window.location.search);
        const param = urlParams.get("nav");
        if (param && param.includes("hidden")) document.body.classList.add("--nav-hidden");
    }
    showPill(section, e) {
        const isLink = e.target.classList.contains(`${this.props.baseClass}-popover-link`);
        const pill = section.querySelector(".js-header-popover-pill");
        if (!pill) return;
        if (!isLink || this.props.isHandheld) {
            pill.classList.remove(this.props.activePillClass);
            return;
        }
        /* Get link's relative position */ const { offsetLeft: offsetLeft, offsetTop: offsetTop, offsetParent: { offsetLeft: sectionOffsetLeft, offsetTop: sectionOffsetTop } } = e.target;
        const pillPosition = {
            x: sectionOffsetLeft + offsetLeft,
            y: sectionOffsetTop + offsetTop
        };
        pill.classList.add(this.props.activePillClass);
        pill.style.transform = `translate(${parseInt(pillPosition.x)}px, ${parseInt(pillPosition.y)}px)`;
    }
    hideAllMenus() {
        this.els.navigationMenus.forEach((menu)=>{
            menu.classList.add(this.props.hiddenClass);
            menu.setAttribute("aria-hidden", "true");
        });
    }
    toggleMenu() {
        const activeMenu = this.getActiveMenu();
        // Hide all menus
        this.hideAllMenus();
        if (!activeMenu) return;
        // Show active menu
        activeMenu.classList.remove(this.props.hiddenClass);
        activeMenu.setAttribute("aria-hidden", "false");
        // Set popover arrow position
        this.setArrowPosition();
        // Set new popover height
        this.setPopoverHeight(activeMenu);
        // Set menu ID in header node
        this.dataset.headerMenu = this.props.activeMenu;
    }
    togglePopover() {
        this.props.isPopoverOpen ? this.openPopover() : this.closePopover();
    }
    bindEvents() {
        window.addEventListener("resize", (e)=>this.resizeHandler());
        if (this.classList.contains("-nav-hidden")) this.parentElement.setAttribute("style", "position: relative");
        else window.addEventListener("scroll", (e)=>this.handleScroll());
        if (!this.props.isHandheld) {
            if (this.els.navigation) this.els.navigation.addEventListener("mouseover", (e)=>this.navigationHandler(e));
            this.addEventListener("mouseleave", (e)=>this.propsProxy.isPopoverOpen = false);
            if (this.els.popoverSections) this.els.popoverSections.forEach((popoverSection)=>{
                popoverSection.addEventListener("mouseover", (e)=>this.showPill(popoverSection, e));
                popoverSection.addEventListener("mouseout", (e)=>this.hidePill(popoverSection, e));
            });
        } else {
            if (this.els.popover) this.els.popover.addEventListener("click", (e)=>{
                if (e.target.classList.contains("js-header-nav-single") || e.target.closest(".js-header-nav-single")) {
                    setTimeout(()=>{
                        this.propsProxy.isPopoverOpen = false;
                    }, 150); // Pequeño delay para mejor UX
                    return;
                }
                this.navigationHandler(e);
            });
            if (this.els.closeButton) this.els.closeButton.addEventListener("click", ()=>this.propsProxy.isPopoverOpen = false);
            if (this.els.openButton) this.els.openButton.addEventListener("click", ()=>this.propsProxy.isPopoverOpen = true);
        }
    }
    connectedCallback() {
        this.hideLinksHeader();
        this.setHandheld();
        this.bindEvents();
    }
}
customElements.define("m-header", $bbbe65f8167975af$var$Header);

});

parcelRegister("8PP6h", function(module, exports) {
class $66eab99dd212aa92$var$Hero extends HTMLElement {
    constructor(){
        super();
        this.props = {
            baseClass: "js-hero"
        };
        this.els = {
            iframe: this.querySelector(`.${this.props.baseClass}-iframe`),
            scrollDownButton: this.querySelector(`.${this.props.baseClass}-scroll-down`)
        };
    }
    hasAccessToIframe() {
        const key = `${+new Date}_${Math.random()}`;
        try {
            const iframe = this.els.iframe.contentWindow;
            iframe[key] = "asd";
            return iframe[key] === "asd";
        } catch  {
            return false;
        }
    }
    scrollDown() {
        this.nextElementSibling.scrollIntoView();
    }
    setIframeHeight() {
        if (!this.hasAccessToIframe()) return;
        const iframeDOM = this.els.iframe.contentWindow.document;
        const iframeHeight = iframeDOM.body.offsetHeight;
        const heightIsInteger = iframeHeight === parseInt(iframeHeight, 10);
        if (heightIsInteger) this.els.iframe.style.height = `${iframeHeight}px`;
    }
    bindEvents() {
        this.els.iframe?.addEventListener("load", (e)=>this.setIframeHeight(e));
        this.els.scrollDownButton?.addEventListener("click", (e)=>this.scrollDown(e));
    }
    connectedCallback() {
        this.bindEvents();
    }
}
customElements.define("m-hero", $66eab99dd212aa92$var$Hero);

});

parcelRegister("aWGtl", function(module, exports) {
class $7f80444cacee39aa$var$MFooter extends HTMLElement {
    constructor(){
        super();
        // Inicialización de referencias a elementos del DOM
        this.els = {};
    }
    // Método para añadir listeners y lógica inicial
    init() {
        // Listener para cambios en el selector de país
        this.els.countrySelector = this.querySelector('[data-trigger="countrySelector"]');
        if (this.els.countrySelector) {
            this.els.countrySelector.addEventListener("change", (event)=>{
                window.location.href = event.target.value;
            });
            this.renderCurrentCountry();
        }
        // Listener para el toggle de contenido en headers
        this.els.headers = this.querySelectorAll(".m-footer__group header");
        this.els.headers.forEach((header)=>{
            header.addEventListener("click", ()=>{
                if (window.innerWidth < 767) {
                    const group = header.parentElement;
                    group.classList.toggle("--show");
                    const icon = group.querySelector(".e-icon");
                    if (icon) {
                        icon.classList.toggle("-direction_down_md");
                        icon.classList.toggle("-direction_up_md");
                    }
                    const content = group.querySelector(".m-footer__content");
                    if (group.classList.contains("--show")) {
                        const height = content.scrollHeight + "px";
                        content.style.maxHeight = height;
                    } else content.style.maxHeight = null;
                }
            });
        });
    }
    // Método para seleccionar el país actual basado en la URL
    renderCurrentCountry() {
        const countryCodeRegex = /^\/(\w{2})/;
        if (countryCodeRegex.test(window.location.pathname)) {
            const countryCode = countryCodeRegex.exec(window.location.pathname)[1];
            const optionNode = this.els.countrySelector.querySelector(`[value^="/${countryCode}"]`);
            if (optionNode) optionNode.setAttribute("selected", true);
        }
    }
    // Método del ciclo de vida llamado cuando el elemento se conecta al DOM
    connectedCallback() {
        this.init();
    }
}
customElements.define("m-footer", $7f80444cacee39aa$var$MFooter);

});

parcelRegister("eBSHL", function(module, exports) {
class $aa2ef4a76db96f2c$var$MTabs extends HTMLElement {
    constructor(){
        super();
        // Inicialización de propiedades directamente en el constructor para claridad
        this.tabs = this.querySelectorAll(".m-tabs__tab");
        this.contents = this.querySelectorAll('.m-tabs__content > div[role="tabpanel"]');
        this.contentContainer = this.querySelector(".m-tabs__content");
        this.currentIndex = this.determineInitialTabIndex(); // Determina el índice inicial aquí para centralizar la lógica
        // Añadir un contenedor para el contenido
        this.contentWrapper = document.createElement("div");
        this.contentWrapper.className = "m-tabs__content-wrapper";
        this.contentContainer.parentNode.insertBefore(this.contentWrapper, this.contentContainer);
        this.contentWrapper.appendChild(this.contentContainer);
        this.setupTabs();
        this.adjustTranslateX(); // Ajusta el translateX basado en el índice inicial
        // Asegurar que la altura se calcule después de que todo esté cargado
        if (document.readyState === "complete") this.initializeHeight();
        else window.addEventListener("load", ()=>this.initializeHeight());
        window.addEventListener("resize", ()=>{
            this.adjustTranslateX();
            this.adjustContentHeight();
        });
    }
    setupTabs() {
        this.tabs.forEach((tab, index)=>{
            tab.addEventListener("click", (e)=>{
                e.preventDefault();
                this.updateActiveTab(index); // Usa el índice para manejar el tab activo
            });
        });
    }
    adjustTranslateX() {
        const containerWidth = this.contentContainer.offsetWidth;
        const offset = this.currentIndex * -containerWidth;
        this.contentContainer.style.transform = `translateX(${offset}px)`;
    }
    updateActiveTab(selectedIndex) {
        this.currentIndex = selectedIndex; // Actualiza el índice actual
        // Actualiza la clase --tab-active y el atributo aria-selected para los tabs
        this.tabs.forEach((tab, index)=>{
            const isActive = index === selectedIndex;
            tab.classList.toggle("--tab-active", isActive);
            tab.setAttribute("aria-selected", isActive ? "true" : "false");
        });
        // Actualiza la visibilidad de los paneles de contenido
        this.contents.forEach((content, index)=>{
            const isContentActive = index === selectedIndex;
            content.classList.toggle("--is-active", isContentActive);
        });
        this.adjustTranslateX(); // Ajusta el translateX cada vez que se cambia de tab
        this.adjustContentHeight();
    }
    initializeHeight() {
        // Pequeño retraso para asegurar que las imágenes y otros recursos estén cargados
        setTimeout(()=>{
            this.adjustContentHeight();
        }, 100);
    }
    adjustContentHeight() {
        const activeContent = this.contents[this.currentIndex];
        if (activeContent) {
            // Forzar un reflow para asegurar que el contenido esté renderizado
            activeContent.offsetHeight;
            const height = activeContent.scrollHeight;
            this.contentWrapper.style.height = `${height}px`;
        }
    }
    determineInitialTabIndex() {
        // Encuentra el índice del tab que tiene la clase --is-active
        const activeTab = Array.from(this.contents).find((tab)=>tab.classList.contains("--is-active"));
        console.log(activeTab);
        return Math.max(Array.from(this.contents).indexOf(activeTab), 0); // Usa Math.max para asegurar un mínimo de 0
    }
}
customElements.define("m-tabs", $aa2ef4a76db96f2c$var$MTabs);

});

parcelRegister("iaJEL", function(module, exports) {
class $d3ac93931a7e2aa6$var$MCarousel extends HTMLElement {
    // Constantes de clase para selectors y clases
    static get SELECTORS() {
        return {
            CONTAINER: ".m-carousel__items",
            NAV_BUTTONS: ".m-carousel__nav-button",
            ITEMS: ".m-carousel__item",
            LINKS: ".m-carousel__items .c-box.--link",
            RIGHT_ARROW: ".e-icon.--arrow_right_md"
        };
    }
    constructor(){
        super();
        this.state = {
            currentTranslateX: 0,
            totalMoveDistance: 0,
            itemsMoved: 0,
            maxItemsMove: 0
        };
        this.initializeElements();
        this.init();
    }
    /**
   * Inicializa las referencias a elementos del DOM
   */ initializeElements() {
        const container = this.querySelector($d3ac93931a7e2aa6$var$MCarousel.SELECTORS.CONTAINER);
        console.log("Container found:", container);
        const items = container?.querySelectorAll($d3ac93931a7e2aa6$var$MCarousel.SELECTORS.ITEMS);
        console.log("Items found:", items);
        this.elements = {
            carouselContainer: container,
            navButtons: this.querySelectorAll($d3ac93931a7e2aa6$var$MCarousel.SELECTORS.NAV_BUTTONS),
            items: items || [],
            links: this.querySelectorAll($d3ac93931a7e2aa6$var$MCarousel.SELECTORS.LINKS)
        };
    }
    /**
   * Inicializa el componente
   */ init() {
        this.setupEventListeners();
        this.calculateCarouselDimensions();
    }
    /**
   * Configura todos los event listeners
   */ setupEventListeners() {
        this.setupHoverEffects();
        this.setupNavigation();
        this.setupResizeHandler();
    }
    /**
   * Configura el manejador de resize
   */ setupResizeHandler() {
        const debouncedResize = this.debounce(()=>{
            this.calculateCarouselDimensions();
            this.updateCarouselPosition();
        }, 250);
        window.addEventListener("resize", debouncedResize);
    }
    /**
   * Configura los efectos hover
   */ setupHoverEffects() {
        this.elements.links.forEach((elem)=>{
            elem.addEventListener("mouseover", ()=>this.updateSiblingsOpacity(elem, "1"));
            elem.addEventListener("mouseout", ()=>this.updateSiblingsOpacity(elem, "1"));
        });
    }
    /**
   * Actualiza la opacidad de los elementos hermanos
   */ updateSiblingsOpacity(element, opacity) {
        this.getSiblings(element).forEach((sibling)=>{
            sibling.style.opacity = opacity;
        });
    }
    /**
   * Obtiene los elementos hermanos de un elemento
   */ getSiblings(element) {
        return Array.from(element.parentNode.children).filter((child)=>child !== element);
    }
    /**
   * Calcula las dimensiones del carousel
   */ calculateCarouselDimensions() {
        if (!this.elements.items.length) return;
        const itemWidth = this.elements.items[0].offsetWidth;
        const gap = this.getColumnGap();
        this.state.totalMoveDistance = itemWidth + gap;
        const containerWidth = this.elements.carouselContainer.offsetWidth;
        const visibleItems = Math.floor(containerWidth / this.state.totalMoveDistance + 1);
        this.state.maxItemsMove = Math.max(0, this.elements.items.length - visibleItems);
    }
    /**
   * Obtiene el gap entre columnas
   */ getColumnGap() {
        return parseInt(window.getComputedStyle(this.elements.carouselContainer).columnGap, 10) || 0;
    }
    /**
   * Actualiza la posición del carousel
   */ updateCarouselPosition() {
        this.state.currentTranslateX = -this.state.itemsMoved * this.state.totalMoveDistance;
        this.elements.carouselContainer.style.transform = `translateX(${this.state.currentTranslateX}px)`;
    }
    /**
   * Configura la navegación
   */ setupNavigation() {
        this.elements.navButtons.forEach((button)=>{
            button.addEventListener("click", ()=>this.handleNavigation(button));
        });
    }
    /**
   * Maneja la navegación
   */ handleNavigation(button) {
        const isRightButton = button.querySelector($d3ac93931a7e2aa6$var$MCarousel.SELECTORS.RIGHT_ARROW);
        if (isRightButton && this.state.itemsMoved < this.state.maxItemsMove) this.state.itemsMoved++;
        else if (!isRightButton && this.state.itemsMoved > 0) this.state.itemsMoved--;
        this.updateCarouselPosition();
    }
    /**
   * Utilidad para hacer debounce de una función
   */ debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = ()=>{
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
}
customElements.define("m-carousel", $d3ac93931a7e2aa6$var$MCarousel);

});

parcelRegister("9nY2T", function(module, exports) {
class $6d54d6d546230339$var$Accordion extends HTMLElement {
    constructor(){
        super();
        this.isAnimating = false; // Variable para rastrear si hay una animación en curso
    }
    connectedCallback() {
        this.addEventListener("click", (e)=>{
            const titleElement = e.target.closest("[data-title]");
            if (titleElement && !this.isAnimating) this.toggleContent(titleElement);
        });
    }
    toggleContent(titleElement) {
        // Establecer la bandera de animación
        this.isAnimating = true;
        const articleElement = titleElement.closest("article");
        const contentElement = articleElement.querySelector("[data-content]");
        const isActive = articleElement.classList.contains("--active");
        const currentActive = this.querySelector("article.--active");
        // Cerrar el acordeón activo si existe y es diferente
        if (currentActive && currentActive !== articleElement) {
            const activeContent = currentActive.querySelector("[data-content]");
            activeContent.style.height = activeContent.scrollHeight + "px";
            activeContent.offsetHeight;
            activeContent.style.height = "0px";
            currentActive.classList.remove("--active");
        }
        // Toggle del estado actual
        if (isActive) {
            contentElement.style.height = contentElement.scrollHeight + "px";
            contentElement.offsetHeight;
            contentElement.style.height = "0px";
            setTimeout(()=>{
                articleElement.classList.remove("--active");
                // Liberar la bandera de animación después de completar
                setTimeout(()=>{
                    this.isAnimating = false;
                }, 50);
            }, 10);
        } else {
            articleElement.classList.add("--active");
            contentElement.style.height = "auto";
            const height = contentElement.scrollHeight;
            contentElement.style.height = "0px";
            contentElement.offsetHeight;
            contentElement.style.height = height + "px";
            // Liberar la bandera de animación después de la duración de la transición
            setTimeout(()=>{
                contentElement.style.height = "auto";
                this.isAnimating = false;
            }, 550); // Un poco más que la duración de la transición
        }
    }
}
customElements.define("c-accordion", $6d54d6d546230339$var$Accordion);

});

parcelRegister("beTmH", function(module, exports) {
class $82ebf2e087033130$var$Secondarymenu extends HTMLElement {
    constructor(){
        super();
    }
    get buttonSecondaryMenu() {
        return this.querySelector('[data-trigger="toggleSecondaryMenu"]');
    }
    get secondaryMenuContent() {
        return this.querySelector('[data-trigger="toggleSecondaryMenu"] + ul');
    }
    get menuLinks() {
        return this.querySelectorAll("a");
    }
    getPathWithoutLocale(url) {
        const path = url.includes("://") ? new URL(url).pathname : url;
        const pathParts = path.split("/").slice(2).filter(Boolean);
        const cleanPath = pathParts.filter((part)=>part !== "page").join("/");
        return "/" + cleanPath;
    }
    setActiveMenuItem() {
        const currentPath = this.getPathWithoutLocale(location.pathname);
        this.menuLinks.forEach((link)=>{
            const linkPath = this.getPathWithoutLocale(link.getAttribute("href"));
            if (linkPath === "/empresas" || linkPath === "/") {
                const isRootSection = currentPath === linkPath || currentPath === "" || currentPath === "/";
                link.classList.toggle("--active", isRootSection);
            } else if (linkPath === currentPath || currentPath.startsWith(linkPath + "/")) link.classList.add("--active");
        });
    }
    bind() {
        this.buttonSecondaryMenu.addEventListener("click", ()=>{
            this.secondaryMenuContent.classList.toggle("--open");
        });
    }
    connectedCallback() {
        this.bind();
        this.setActiveMenuItem();
    }
}
customElements.define("m-secondarymenu", $82ebf2e087033130$var$Secondarymenu);

});

parcelRegister("cVG6C", function(module, exports) {
class $969b78369a7b4fbd$var$Testimonial extends HTMLElement {
    constructor(){
        super();
        this.currentIndex = 0;
        this.slides = [];
    }
    connectedCallback() {
        // Obtener referencias a los elementos
        this.slides = this.querySelectorAll(".m-testimonial__items");
        this.prevBtn = this.querySelector(".m-testimonial__nav-button.--prev");
        this.nextBtn = this.querySelector(".m-testimonial__nav-button.--next");
        // Referencia a la barra de progreso
        this.progressIndicator = this.querySelector(".m-testimonial__progress-indicator");
        // Inicializar el carrusel
        this.initializeCarousel();
        // Configurar event listeners
        this.setupEventListeners();
    }
    initializeCarousel() {
        // Ocultar todos los slides excepto el primero
        this.slides.forEach((slide, index)=>{
            if (index === 0) slide.classList.add("--active");
            else slide.classList.remove("--active");
        });
        // Inicializar la barra de progreso
        this.updateProgressBar(0);
    }
    setupEventListeners() {
        // Event listeners para botones de navegación
        if (this.prevBtn) this.prevBtn.addEventListener("click", ()=>this.showSlide(this.currentIndex - 1));
        if (this.nextBtn) this.nextBtn.addEventListener("click", ()=>this.showSlide(this.currentIndex + 1));
    }
    showSlide(index) {
        // Manejar índices circulares
        if (index < 0) index = this.slides.length - 1;
        if (index >= this.slides.length) index = 0;
        // Ocultar todos los slides
        this.slides.forEach((slide)=>slide.classList.remove("--active"));
        // Mostrar el slide seleccionado
        this.slides[index].classList.add("--active");
        // Actualizar el índice actual
        this.currentIndex = index;
        // Actualizar la barra de progreso
        this.updateProgressBar(index);
    }
    updateProgressBar(index) {
        // Actualizar el ancho de la barra de progreso
        if (this.progressIndicator) {
            const progressPercentage = (index + 1) / this.slides.length * 100;
            this.progressIndicator.style.width = `${progressPercentage}%`;
        }
    }
}
// Registrar el elemento personalizado
customElements.define("m-testimonial", $969b78369a7b4fbd$var$Testimonial);

});

parcelRegister("8INrU", function(module, exports) {
class $6598ca5aa87fb120$var$Banner extends HTMLElement {
    constructor(){
        super();
        // Solo inicializamos la clave de almacenamiento en el constructor
        this.storageKey = ""; // Se inicializa correctamente en connectedCallback
    }
    get closeButton() {
        return this.querySelector("[data-trigger=close]");
    }
    /**
   * Verifica si el banner debe mostrarse y gestiona su visibilidad
   */ handleDefaultVisibility() {
        const closedData = this.getClosedData();
        if (closedData) {
            // Si está configurado para nunca mostrar de nuevo
            if (closedData.expirationDays === 0) {
                this.hideBanner();
                return;
            }
            // Verificamos si ya pasó el tiempo de expiración
            const closedTime = new Date(closedData.timestamp);
            const currentTime = new Date();
            const diffTime = currentTime - closedTime;
            const diffDays = diffTime / 86400000;
            if (diffDays < closedData.expirationDays) // No ha expirado, mantenemos oculto
            this.hideBanner();
            else {
                // Ya expiró, mostramos el banner
                this.showBanner();
                this.removeClosedData();
            }
        } else // Si no hay datos de cierre, mostramos el banner
        this.showBanner();
    }
    /**
   * Guarda en localStorage la información de cuándo se cerró el banner
   */ saveClosedData() {
        const data = {
            timestamp: new Date().toISOString(),
            expirationDays: this.expirationDays
        };
        localStorage.setItem(this.storageKey, JSON.stringify(data));
    }
    /**
   * Recupera la información guardada del cierre del banner
   */ getClosedData() {
        const data = localStorage.getItem(this.storageKey);
        return data ? JSON.parse(data) : null;
    }
    /**
   * Elimina la información guardada del cierre del banner
   */ removeClosedData() {
        localStorage.removeItem(this.storageKey);
    }
    hideBanner() {
        this.classList.add("hidden");
    }
    showBanner() {
        this.classList.remove("hidden");
    }
    handleCloseButton(e) {
        this.hideBanner();
        // Guardamos la información del cierre
        this.saveClosedData();
    }
    connectedCallback() {
        // Inicializamos el ID para la clave de almacenamiento
        if (this.id) this.storageKey = `banner-${this.id}-closed`;
        // Convertimos el atributo expiration-days a número
        this.expirationDays = 0; // Valor por defecto: nunca mostrar de nuevo
        if (this.hasAttribute("expiration-days")) this.expirationDays = parseInt(this.getAttribute("expiration-days"), 10) || 0;
        this.bind();
        this.handleDefaultVisibility();
    }
    bind() {
        if (this.closeButton) this.closeButton.addEventListener("click", (e)=>this.handleCloseButton(e));
    }
}
customElements.define("c-banner", $6598ca5aa87fb120$var$Banner);

});

parcelRegister("6lnS6", function(module, exports) {
class $49e738a189a356b6$var$Success extends HTMLElement {
    get messageNode() {
        return this.querySelector("[data-render=message]");
    }
    showMessage(message) {
        this.messageNode.innerText = message;
    }
    connectedCallback() {
        const urlParams = new URLSearchParams(window.location.search);
        const param = urlParams.get("message");
        if (param) this.showMessage(param);
    }
}
customElements.define("c-success", $49e738a189a356b6$var$Success);

});

parcelRegister("4r6RI", function(module, exports) {
class $33af025817457185$var$YouTubeVideo extends HTMLElement {
    get videoCover() {
        return this.querySelector('[data-node="youtubeCover"]');
    }
    get videoSrc() {
        return this.videoCover.getAttribute("data-video");
    }
    get videoFrame() {
        return this.querySelector('[data-node="youtubeIframe"]');
    }
    hideCover() {
        this.videoCover.classList.add("fade-out");
    }
    addIframeSrc() {
        this.hideCover();
        this.videoFrame.src = this.videoSrc + "&autoplay=1";
        this.initPlayer();
    }
    initPlayer() {
        this.player = new YT.Player(this.videoFrame, {
            events: {
                "onStateChange": this.onPlayerStateChange.bind(this)
            }
        });
        this.videoId = this.videoFrame.getAttribute("id");
    }
    onPlayerStateChange(event) {
        const videoData = event.target.getVideoData();
        if (event.data === YT.PlayerState.PLAYING && !this.hasPlayed) {
            this.hasPlayed = true;
            this.videoDuration = this.player.getDuration();
            this.sendVideoEvent("play", videoData, 0);
            this.trackProgress(videoData);
        } else if (event.data === YT.PlayerState.ENDED) this.sendVideoEvent("ended", videoData, 100);
    }
    trackProgress(videoData) {
        const intervals = [
            0.3,
            0.5,
            0.8
        ];
        let tracked = {
            "0.3": false,
            "0.5": false,
            "0.8": false
        };
        this.progressInterval = setInterval(()=>{
            const currentTime = this.player.getCurrentTime();
            const percentWatched = currentTime / this.videoDuration;
            intervals.forEach((interval)=>{
                if (!tracked[interval] && percentWatched >= interval) {
                    tracked[interval] = true;
                    this.sendVideoEvent("progress", videoData, interval * 100);
                }
            });
            if (percentWatched >= 1) clearInterval(this.progressInterval);
        }, 3000);
    }
    sendVideoEvent(status, videoData, percent) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "gtm.video",
            "gtm.videoUrl": this.videoSrc,
            "gtm.videoTitle": videoData.title,
            "gtm.videoDuration": this.videoDuration,
            "gtm.videoPercent": percent,
            "gtm.videoStatus": status,
            "gtm.videoId": this.videoId
        });
    }
    connectedCallback() {
        this.bind();
    }
    bind() {
        this.videoCover.addEventListener("click", (e)=>this.addIframeSrc(e));
    }
}
customElements.define("c-youtube-video", $33af025817457185$var$YouTubeVideo);

});

parcelRegister("2z75a", function(module, exports) {
class $1de45814d595a588$var$CookiesUI extends HTMLElement {
    constructor(){
        super();
        this.initializeComponent();
    }
    initializeComponent() {
        if (this.hasConsent()) this.noShowCookies();
        else {
            if (this.isTargetActive()) this.hideBanner();
            this.showCookies();
            this.setupCloseButtonListener();
            this.addEventListeners();
        }
    }
    isTargetActive() {
        const cookieBanner = document.getElementById("cookiedialog");
        if (!cookieBanner) return false;
        const currentFragment = window.location.hash; // Obtiene el fragmento del URL actual
        return currentFragment === `#${cookieBanner.id}`;
    }
    hasConsent() {
        return localStorage.getItem("cookie_acceptance") !== null;
    }
    // If we need to check the cookie instead of localstorage  
    //  hasConsent() {
    //  return document.cookie.includes("cookie_acceptance");
    //  }
    addEventListeners() {
        this.addEventListener("click", (event)=>{
            this.handleButtonClick(event);
        });
    }
    handleButtonClick(event) {
        const trigger = event.target.dataset.trigger;
        switch(trigger){
            case "save":
                this.saveConsentAndCloseBanner();
                this.sendGTM("launch_gtm");
                break;
            case "saveall":
                this.saveAll();
                this.saveConsentAndCloseBanner();
                this.sendGTM("launch_gtm");
                break;
            case "deniedall":
                this.deniedall();
                this.noShowCookies();
                this.sendGTM("cookie_denied");
                break;
            case "savedialog":
                this.closeDialog();
                this.saveConsent();
                this.noShowCookies();
                this.sendGTM("launch_gtm");
                break;
            case "openpreferences":
                this.openPreferences();
                this.sendGTM("cookies_dialog_open");
                break;
            default:
                if (event.target.dataset.title === "") this.toggleContent(event.target);
                break;
        }
    }
    saveConsentAndCloseBanner() {
        this.saveConsent();
        this.noShowCookies();
    }
    saveAll() {
        this.querySelectorAll('input[type="checkbox"]').forEach((checkbox)=>{
            if (!checkbox.disabled) checkbox.checked = true;
        });
    }
    updateConsent(checkboxLogic) {
        const currentConsent = JSON.parse(localStorage.getItem("cookie_acceptance")) || {};
        const currentTime = new Date().getTime();
        const consent = {
            consent_date_first: currentConsent.consent_date_first || currentTime,
            consent_update: currentTime
        };
        this.querySelectorAll('input[type="checkbox"]').forEach((checkbox)=>{
            const checkboxName = checkbox.getAttribute("data-name");
            consent[checkboxName] = checkboxLogic(checkbox);
        });
        localStorage.setItem("cookie_acceptance", JSON.stringify(consent));
        return consent;
    }
    deniedall() {
        this.updateConsent((checkbox)=>checkbox.disabled ? "granted" : "denied");
        this.noShowCookies();
    //    this.saveCookie(); 
    }
    saveConsent() {
        const consent = this.updateConsent((checkbox)=>checkbox.checked ? "granted" : "denied");
        this.sendGTM("cookie_acceptance");
    //    this.saveCookie(); 
    }
    //    saveCookie() {
    //      const consent = JSON.parse(localStorage.getItem("cookie_acceptance")) || {};
    //      const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000); // 1 year expiry
    //  
    //      document.cookie = `cookie_acceptance=${JSON.stringify(consent)}; domain:.cabify.com; expires=${expiryDate.toUTCString()}; path=/`;
    //  }
    closeDialog() {
        const scrollY = window.scrollY;
        window.location.hash = "";
        window.scroll(0, scrollY);
    }
    setupCloseButtonListener() {
        const buttonClose = document.querySelector('#cookiedialog [title="Cerrar"]');
        if (buttonClose) buttonClose.addEventListener("click", (e)=>{
            this.toggleCookies();
        });
    }
    openPreferences() {
        this.hideBanner();
        window.location.hash = "cookiedialog"; // Cambia el fragmento de URL
    }
    noShowCookies() {
        document.querySelector("c-cookies").classList.add("-hidden");
    }
    showCookies() {
        document.querySelector("c-cookies").classList.remove("-hidden");
        this.sendGTM("cookies_banner_open");
    }
    toggleCookies() {
        document.querySelector(".banner").classList.toggle("-hidden");
    }
    hideBanner() {
        document.querySelector(".banner").classList.add("-hidden");
    }
    toggleContent(clickedElement) {
        const articleElement = clickedElement.closest("article");
        const currentActive = this.querySelector("article.-active");
        if (currentActive && currentActive !== articleElement) currentActive.classList.remove("-active");
        articleElement.classList.toggle("-active");
    }
    sendGTM(keyEvent, valueEvent) {
        if (typeof window.dataLayer !== "undefined") {
            window.dataLayer = window.dataLayer || [];
            if (valueEvent) //console.log(keyEvent, valueEvent);
            window.dataLayer.push({
                event: keyEvent,
                value: valueEvent
            });
            else //console.log(keyEvent);
            window.dataLayer.push({
                event: keyEvent
            });
        } else console.log("GTM no est\xe1 definido a\xfan.");
    }
}
customElements.define("c-cookies", $1de45814d595a588$var$CookiesUI);

});

parcelRegister("5gQD3", function(module, exports) {
/*

  Script to propagate all query params in the current url to any link clicked on the page.
  This help us minimise duplicated pages on Google Search and allow us to have complete tracing of campaign visitors that browse our site.
  More info: https://developers.google.com/search/blog/2007/09/google-duplicate-content-caused-by-url

*/ let $3d67455d09d61982$var$queryParams = new URLSearchParams(window.location.search);
// Array of parameters to exclude
const $3d67455d09d61982$var$excludedParams = [
    "message",
    "session",
    "temp",
    "token"
];
function $3d67455d09d61982$var$appendQueryParams(url) {
    if (!$3d67455d09d61982$var$queryParams.toString()) return url;
    let concatChar = url.indexOf("?") != -1 ? "&" : "?";
    let filteredParams = new URLSearchParams();
    // Filter out excluded parameters
    for (let [key, value] of $3d67455d09d61982$var$queryParams.entries())if (!$3d67455d09d61982$var$excludedParams.includes(key)) filteredParams.append(key, value);
    let encodedParams = decodeURIComponent(filteredParams.toString());
    let processedParams = encodedParams.replace(/\?/g, "&");
    return `${url}${concatChar}${processedParams}`;
}
// Delegate click on every <a/> tag
document.body.addEventListener("click", (e)=>{
    // Support <a/> tags with child elements
    let target = e.target.tagName === "A" ? e.target : e.target.closest("a");
    if (target && target.hasAttribute("href") && $3d67455d09d61982$var$queryParams.toString() !== "") {
        let currentHref = target.getAttribute("href");
        // Make sure links to cabify.com or to an absolute path
        let pointsToCabify = currentHref.indexOf("cabify.com") != -1 || currentHref.startsWith("/");
        if (pointsToCabify) target.setAttribute("href", $3d67455d09d61982$var$appendQueryParams(currentHref));
    }
});
// Propagate query params to heroiframe component
// Make sure we have query params and a heroiframe component on the page
let $3d67455d09d61982$var$iframe = document.querySelector("[data-select=heroiframe], .js-hero-iframe");
if ($3d67455d09d61982$var$queryParams.toString() !== "" && $3d67455d09d61982$var$iframe) $3d67455d09d61982$var$iframe.setAttribute("src", $3d67455d09d61982$var$appendQueryParams($3d67455d09d61982$var$iframe.src));

});

parcelRegister("5g7S1", function(module, exports) {
// Delegate click on every <a/> tag instead of attaching individual listeners to avoid performance issues:
document.body.addEventListener("click", (e)=>{
    // Support <a/> tags with child elements
    let target = e.target.tagName === "A" ? e.target : event.target.closest("a");
    // Make sure we have a valid target, with href attribute.
    if (target && target.hasAttribute("href")) {
        let currentHref = target.getAttribute("href");
        // Detect links to cabify.com or to an absolute path
        // This MR https://gitlab.otters.xyz/product/design/comms/web/web-poc/-/merge_requests/1524/diffs?commit_id=cf264da1c2ffd00500e976ffea54164c13fed0f9#af262def88107d1205991c4cedeb65af6acec546
        let pointsToCabify = currentHref.indexOf("cabify.com") != -1 || currentHref.indexOf("cabifylogistics.com") != -1 || currentHref.startsWith("/");
        // Detect downloads links hosted at cabify.com or to an absolute path
        let isDownloadsLocationAnyFile = currentHref.startsWith("/static/downloads/") && currentHref.lastIndexOf(".");
        let isPDF = currentHref.lastIndexOf(".pdf") > -1;
        // Check if href starts with #
        let startsWithHash = currentHref.startsWith("#");
        if (isDownloadsLocationAnyFile || isPDF) target.setAttribute("download", "");
        if (!pointsToCabify) target.setAttribute("target", "_blank");
        if (startsWithHash) {
            e.preventDefault();
            // Scroll to the target anchor
            let targetElement = document.querySelector(currentHref);
            if (targetElement) targetElement.scrollIntoView({
                behavior: "smooth"
            });
        }
    }
});

});

parcelRegister("6vcqP", function(module, exports) {
class $4bbf47fb7ac0a309$var$Dialog extends HTMLElement {
    get closeButton() {
        return this.querySelector("[data-trigger=close]");
    }
    closeDialog(event) {
        var url = window.location.pathname;
        var scroll = window.scrollY;
        // When closing there is a buggy # left.
        // Having a <base> tag during migration brings odd behaviours if we try to remove it programatically
        // For now we live with the buggy # until we finish the migration.
        window.location.hash = "" // hides the modal
        ;
        window.scroll(0, scroll) // makes sure scroll does not move
        ;
        event.preventDefault();
    }
    connectedCallback() {
        this.bind();
    }
    bind() {
        this.closeButton.addEventListener("click", (e)=>{
            this.closeDialog(e);
        });
    }
}
customElements.define("c-dialog", $4bbf47fb7ac0a309$var$Dialog);

});

parcelRequire("g7m2H");
parcelRequire("8PP6h");
parcelRequire("aWGtl");
parcelRequire("eBSHL");
parcelRequire("iaJEL");
parcelRequire("9nY2T");
parcelRequire("beTmH");
parcelRequire("cVG6C");
parcelRequire("8INrU");
parcelRequire("6lnS6");
parcelRequire("4r6RI");
parcelRequire("2z75a");
parcelRequire("5gQD3");
parcelRequire("5g7S1");
parcelRequire("6vcqP");

})();
//# sourceMappingURL=techblog.js.map
